/*
 * File: InputSwitchStatement.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Returns the input type based on the prop field and passes all the props from the parent
 */
import React from "react";
import InputText from "./inputs/InputText";
import InputCheckbox from "./inputs/InputCheckbox";
import InputDate from "./inputs/InputDate";
import InputEmail from "./inputs/InputEmail";
import InputSelect from "./inputs/InputSelect";
import InputTextArea from "./inputs/InputTextArea";
import InputRadio from "./inputs/InputRadio";
import InputPhone from "./inputs/InputPhone";
import InputTime from "./inputs/InputTime";
import InputZip from "./inputs/InputZip";
import InputNumberFormat from "./inputs/InputNumberFormat";
import InputAutocomplete from "./inputs/InputAutocomplete";
import InputSwitch from "./inputs/InputSwitch";
import InputDateTime from "./inputs/InputDateTime";
import SectionHeader from "./inputs/SectionHeader";
import PropTypes from "prop-types";

const InputSwitchStatement = props => {
  const setErrorMessage = message => {
    props.field.updateErrorMessage(message);
  };

  switch (props.field.type) {
    case "sectionHeader":
      return <SectionHeader {...props} />;

    case "checkbox":
      return <InputCheckbox {...props} />;

    case "date":
      return <InputDate {...props} />;

    case "time":
      return <InputTime {...props} />;

    case "datetime":
      return <InputDateTime {...props} />;

    case "email":
      return <InputEmail {...props} />;

    case "phone":
      return <InputPhone {...props} />;

    case "zip":
      return <InputZip {...props} />;

    case "radio":
      return <InputRadio {...props} />;

    case "select":
      return <InputSelect {...props} />;

    case "textarea":
      return <InputTextArea {...props} />;

    case "integer":
      return <InputNumberFormat {...props} setErrorMessage={setErrorMessage} />;

    case "decimal":
      return (
        <InputNumberFormat
          {...props}
          setErrorMessage={setErrorMessage}
          allowDecimals
        />
      );

    case "autocomplete":
      return <InputAutocomplete {...props} />;

    case "switch":
      return <InputSwitch {...props} />;

    default:
      return <InputText {...props} />;
  }
};

InputSwitchStatement.propTypes = {
  field: PropTypes.object
};

export default InputSwitchStatement;
